import { define } from '@rlean/core';

const FormTemplateElementType = define('formTemplateElementType', {
  initialState: {},
  nullableParams: true,
  getURL: '/FormTemplateElementType',
  postURL: '/FormTemplateElementType',
});

export default FormTemplateElementType;
